import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5929e854"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onKeydown"]
const _hoisted_2 = { class: "p-2 resulthead" }

import { ref } from 'vue';
import { ComplexDownload, SimpleDownload } from '../../types';


export default /*#__PURE__*/_defineComponent({
  props: {
    sort: null,
    keys: null,
    currentKey: null
  },
  setup(__props: any) {

const props = __props as {
  sort: (key: keyof (SimpleDownload | ComplexDownload), direction: boolean) => void;
  keys: (keyof (SimpleDownload | ComplexDownload))[];
  currentKey: keyof (SimpleDownload | ComplexDownload);
}



const currentDirection = ref(true);

const handleSort = (key: keyof (SimpleDownload | ComplexDownload)) => {
  if (key !== props.currentKey) currentDirection.value = false;
  props.sort(key, !currentDirection.value);
  currentDirection.value = !currentDirection.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.keys, (key, index) => {
      return (_openBlock(), _createElementBlock("th", {
        key: key + index,
        onClick: ($event: any) => (handleSort(key)),
        onKeydown: ($event: any) => (handleSort(key))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t(key)) + " ", 1),
          (__props.currentKey === key)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(!currentDirection.value ? 'newicon-40-1' : 'newicon-39-1')
              }, null, 2))
            : _createCommentVNode("", true)
        ])
      ], 40, _hoisted_1))
    }), 128))
  ]))
}
}

})